export { default } from './ClipButton';
